export default "__VITE_ASSET__31e5fbb6__"